import MapboxDraw, {
  DrawCustomModeThis,
  MapMouseEvent,
  MapTouchEvent,
} from '@mapbox/mapbox-gl-draw';
import simplify from '@turf/simplify';
const DrawPolygon = MapboxDraw.modes.draw_polygon;
const { geojsonTypes, cursors, types, updateActions, modes, events } =
  MapboxDraw.constants;

type FreehandFunctions = {
  fireUpdate: () => void;
  simplify: (polygon: any) => void;
};

type FreehandModeThis = DrawCustomModeThis & FreehandFunctions;

const FreehandMode: typeof DrawPolygon & FreehandFunctions = {
  ...DrawPolygon,
} as any;

FreehandMode.onSetup = function () {
  const polygon = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POLYGON,
      coordinates: [[]],
    },
  });

  this.addFeature(polygon);
  this.clearSelectedFeatures();

  // disable dragPan
  setTimeout(() => {
    if (!this.map || !this.map.dragPan) return;
    this.map.dragPan.disable();
  }, 0);

  this.updateUIClasses({ mouse: cursors.ADD });
  this.activateUIButton(types.POLYGON);
  this.setActionableState({
    trash: true,
    combineFeatures: false,
    uncombineFeatures: false,
  });

  return {
    polygon,
    currentVertexPosition: 0,
    dragMoving: false,
  };
};

FreehandMode.onDrag = FreehandMode.onTouchMove = function (
  state,
  e: MapTouchEvent | MapMouseEvent
) {
  state.dragMoving = true;
  this.updateUIClasses({ mouse: cursors.ADD });
  state.polygon.updateCoordinate(
    `0.${state.currentVertexPosition}`,
    e.lngLat.lng,
    e.lngLat.lat
  );
  state.currentVertexPosition++;
  state.polygon.updateCoordinate(
    `0.${state.currentVertexPosition}`,
    e.lngLat.lng,
    e.lngLat.lat
  );
};

FreehandMode.onMouseUp = function (state) {
  if (state.dragMoving) {
    this.simplify(state.polygon);
    this.fireUpdate();
    this.changeMode(modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
  }
};

FreehandMode.onTouchEnd = function (state, e) {
  this.onMouseUp?.(state, e as any);
};

FreehandMode.fireUpdate = function (this: FreehandModeThis) {
  this.map.fire(events.UPDATE, {
    action: updateActions.MOVE,
    features: this.getSelected().map((f) => f.toGeoJSON()),
  });
};

FreehandMode.simplify = function (this: FreehandModeThis, polygon) {
  const tolerance = 1 / Math.pow(1.08, 10 * this.map.getZoom()); // https://www.desmos.com/calculator/nolp0g6pwr
  simplify(polygon, {
    mutate: true,
    tolerance,
    highQuality: true,
  });
};

// FreehandMode.onStop = function (state) {
//   DrawPolygon.call(this, state);
//   setTimeout(() => {
//     if (!this.map || !this.map.dragPan) return;
//     this.map.dragPan.enable();
//   }, 0);
// };

export default FreehandMode;
